import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../../../../shared/environment.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationDetailService {
  constructor(public http: HttpClient, public env: EnvironmentService) {}
  baseUrl = `${this.env.apiUrl}/notification`;

  fetchAllNotifications(params: any) {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `notification/v1${urlParams}`;
    return this.env.get(url, params);
  }
  updateNotificationStatus(notificationId: string): Observable<any> {
    let url = `notification/${notificationId}`;
    return this.env.patch(`${url}`, {
      status: 'READ',
    });
  }
  getNotification(notificationId: string): Observable<any> {
    let url = `notification/${notificationId}`;
    return this.env.get(`${url}`);
  }
  getLeaveData(leaveId: string): Observable<any> {
    let url = `leaves/${leaveId}`;
    return this.env.get(`${url}`);
  }
  getSwapDutyData(swapDutyId: string): Observable<any> {
    let url = `swap/${swapDutyId}`;
    return this.env.get(`${url}`);
  }
  getAttendanceChangeRequest(typeId: string): Observable<any> {
    let url = `staffs/attendance/change-requests/${typeId}`;
    return this.env.get(`${url}`);
  }
  approveAttendanceChangeRequest(typeId: string, params: any): Observable<any> {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${encodeURIComponent(params[key])}`;
        } else {
          urlParams += `&${key}=${encodeURIComponent(params[key])}`;
        }
      }
    }
    let url = `staffs/attendance/change-requests/${typeId}/approve${urlParams}`;
    return this.env.post(url);
  }
  rejectAttendanceChangeRequest(typeId: string, params: any): Observable<any> {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${encodeURIComponent(params[key])}`;
        } else {
          urlParams += `&${key}=${encodeURIComponent(params[key])}`;
        }
      }
    }
    let url = `staffs/attendance/change-requests/${typeId}/reject${urlParams}`;
    return this.env.post(url);
  }
  getAbsentDutyStemplingRequest(typeId: string): Observable<any> {
    let url = `staffs/attendance/absent-duty-stempling/${typeId}`;
    return this.env.get(`${url}`);
  }
  updateLeaveData(leaveId: string, formData: FormData): Observable<any> {
    let url = `leaves/${leaveId}`;
    return this.env.patchFormData(url, formData);
  }
  updateSwapDutyRequest(params: any) {
    let urlParams = '';
    for (const key in params) {
      if (
        params.hasOwnProperty(key) &&
        params[key] !== undefined &&
        params[key] !== ''
      ) {
        if (urlParams === '') {
          urlParams += `?${key}=${params[key]}`;
        } else {
          urlParams += `&${key}=${params[key]}`;
        }
      }
    }
    let url = `swap/update-status${urlParams}`;
    return this.env.patch(url, params);
  }
}
